// 这里是页端打点，主要是为了和以前的正文页比较
// 精准数据请看啄木鸟：内核打点

import {waPerformance} from './wastat';

function onPerformance(pageOpenTime, firstScreenTime) {
  const timing = performance && performance.timing;
  const navigation = performance && performance.navigation;
    // 重定向次数
  const redirectCount = navigation && navigation.redirectCount;

  if (!timing || timing.requestStart === 0 || timing.responseStart === 0) {
    return;
  }

  // 跳转耗时
  const redirect = timing.redirectEnd - timing.redirectStart;

  // APP CACHE 耗时, 或 fetchTime 没什么价值，也没有优化的可能性存在
  const appcache = Math.max(timing.domainLookupStart - timing.fetchStart, 0);

  // DNS 解析耗时
  const dns = timing.domainLookupEnd - timing.domainLookupStart;

  // TCP 链接耗时
  const conn = timing.connectEnd - timing.connectStart;

  // 等待服务器响应耗时，存在 cache 时，UC 浏览器获取的 requestStart / responseStart 为小于 13 位的数
  let request = timing.responseStart - timing.requestStart;
  // 过滤结果大于 8 位数或小于 0 的值
  request = request > 10000000 || request < 0 ? 0 : request;

  // 内容加载耗时，存在 cache 时，UC 浏览器获取的 responseStart 为小于 13 位的数
  let response = timing.responseEnd - timing.responseStart;
  response = response > 10000000 || response < 0 ? 0 : response;

  // 总体网络交互耗时，即开始跳转到服务器资源下载完成
  const network = timing.responseEnd - timing.navigationStart;

  // 渲染处理
  const processing = (timing.domComplete || timing.domLoading) - timing.domLoading;

  // 抛出 load 事件
  const load = timing.loadEventEnd - timing.loadEventStart;

  // 可交互
  const active = timing.domInteractive - timing.navigationStart;

  // 首屏时间
  const firstScreen = firstScreenTime - timing.navigationStart;

  // 请求响应耗时，即 T0，存在 cache 时，UC 浏览器获取的 requestStart / responseStart 为小于 13 位的数
  const t0 = timing.responseStart - timing.navigationStart;

  // 开始解析渲染 DOM 树，即 T1，即包括了请求响应，文档下载的时间
  const t1 = timing.domLoading - timing.navigationStart;

  // DOM 加载完毕，即 T2
  const t2 = timing.domContentLoadedEventEnd - timing.navigationStart;

  // 内容加载完毕，即 T3
  const t3 = timing.loadEventEnd - timing.navigationStart;

  // 刚解析完title标签，即浏览器能展示页面title的世界
  const domStart = pageOpenTime - timing.navigationStart;

  return {
    redirect,
    appcache,
    dns,
    conn,
    request, // Waiting (TTFB)
    response, // 内容下载时间
    processing, // 渲染时间
    network, // 总体网络交互耗时，即开始跳转到服务器资源下载完成
    load,
    active, // 可交互时间
    redirectCount,
    domStart: domStart < 0 ? 0 : domStart, // 白屏时间
    firstScreen, // 首屏时间
    t0: t0 < 0 ? 0 : t0, // 请求响应耗时
    t1, // 首次出现内容
    t2, // DOM 加载完毕
    t3: t3 < 0 ? 0 : t3, // 内容加载完毕
  };
}

export function performanceInit(pageOpenTime, firstScreenTime, loadedCB) {
  if (!performance) {
    return;
  }

  window.addEventListener('load', function() {
    // performance.timing.loadEventEnd 需要window.onload结束才会有非0的值，所以此处加setTimeout
    setTimeout(function() {
      const pfmData = onPerformance(pageOpenTime || 0, firstScreenTime || 0);
      typeof loadedCB === 'function' && loadedCB(pfmData);
    }, 0);
  }, false);
}

export function performanceInitPage() {
  // [stat] 前端性能打点
  performanceInit((window as any)._START_TIME ? (window as any)._START_TIME : 0,
    (window as any)._FIRST_SCREEN_TIME ? (window as any)._FIRST_SCREEN_TIME : 0,
    function(pfmData) {
      if (pfmData) {
        waPerformance(pfmData);
      }
    });
}
